/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { ReactElement, useContext } from 'react';
import { ErrorPage } from '@components';
import { useFormikContext } from 'formik';
import { iInfringementExtensionFormValues } from '@services/InfringementExtensionService';

// const { REACT_APP_SITECORE_API_ENDPOINT: API_URL, REACT_APP_PATH_FAMILY_VIOLENCE_SCHEME: PATH_FVS } = process.env;
function InfringementExtErrorPage(): ReactElement {
  const { values }: { values: iInfringementExtensionFormValues } = useFormikContext();
  return (
    <>
      <ErrorPage errorMessage={values.submissionError} />
    </>
  );
}

export default InfringementExtErrorPage;
